module.exports = __webpack_public_path__ + "static/media/23004553_1638428146232370_1985241402256820286_o-thumb.521eae7a.jpg";